import clsx from "clsx";
import type React from "react";
import { match } from "ts-pattern";

export const MarketingTitle: React.FC<{
  accent?: "accent" | "primary" | "secondary";
  size?: "sm" | "md";
  title: string;
  subtitle: string;
}> = ({ accent = "secondary", size = "md", title, subtitle }) => {
  return (
    <div className="space-y-1 md:space-y-2">
      <div
        className={clsx(
          "title",
          match(size)
            .with("sm", () => "title-xs")
            .with("md", () => "title-sm")
            .exhaustive(),
          match(accent)
            .with("accent", () => "text-accent")
            .with("primary", () => "text-primary")
            .with("secondary", () => "text-secondary")
            .exhaustive(),
        )}
      >
        {subtitle}
      </div>
      <h2
        className={clsx(
          "title",
          match(size)
            .with("sm", () => "title-lg")
            .with("md", () => "title-xl")
            .exhaustive(),
        )}
      >
        {title}
      </h2>
    </div>
  );
};
